import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';
import { PaletteColor } from '@mui/material';

export const root: SxStyle = {
  p: 2.75,
};

export const topBox: SxStyle = {
  background: (p) => p.palette.grey[300],
  width: '100%',
  height: (p) => p.spacing(1),
  borderRadius: (p) => p.spacing(1, 1, 0, 0),
};

export const functionTab: SxStyle = {
  background: (p) => p.palette.grey[300],
  px: 2,
  pr: 4,
  pb: 0.75,
  borderRadius: (p) => p.spacing(0, 0, 2, 0),
  zIndex: 2,
  position: 'relative',
};

export const funcTabBox1: SxStyle = {
  width: (p) => p.spacing(2),
  height: (p) => p.spacing(2),
  background: (p) => p.palette.common.white,
  position: 'absolute',
  right: (p) => p.spacing(2),
  bottom: 0,
};
export const funcTabBox2: SxStyle = {
  width: (p) => p.spacing(2),
  height: (p) => p.spacing(2),
  background: (p) => p.palette.grey[300],
  borderBottomRightRadius: (p) => p.spacing(1.5),
};

export const tabBox1: SxStyle = {
  width: (p) => p.spacing(2),
  height: (p) => p.spacing(2),
  background: (p) => p.palette.grey[300],
  position: 'absolute',
  right: 0,
  top: 0,
};

export const tabBox2: SxStyle = {
  width: (p) => p.spacing(2),
  height: (p) => p.spacing(2),
  background: (p) => p.palette.common.white,
  borderTopRightRadius: (p) => p.spacing(1.5),
};

export const tab: SxStyle = {
  background: (p) => p.palette.common.white,
  ml: -2,
  px: 2,
  py: 1,
  borderRadius: (p) => p.spacing(1.5, 2, 0, 0),
  zIndex: 3,
  position: 'relative',
};

export const favicon: SxStyle = {
  width: (p) => p.spacing(2),
  height: (p) => p.spacing(2),
  background: (p) => p.palette.success[100],
};

export const companyName: SxStyle = {
  fontSize: (p) => p.typography.caption,
  width: (p) => p.spacing(7),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const dot: SxStyleFunc<PaletteColor> = (color) => ({
  width: (p) => p.spacing(1.75),
  height: (p) => p.spacing(1.75),
  borderRadius: '50%',
  backgroundColor: color[400],
});

export const addSection: SxStyle = {
  flex: 1,
  backgroundColor: (p) => p.palette.grey[300],
  borderBottomLeftRadius: (p) => p.spacing(1.5),
  pl: 2,
  pb: 0.5,
};

export const searchBar: SxStyle = {
  flex: 1,
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(2),
  padding: (p) => p.spacing(0.75, 1.5),
};

export const avatar: SxStyle = {
  background: (p) => p.palette.grey[400],
  borderRadius: '50%',
  width: (p) => p.spacing(2.75),
  height: (p) => p.spacing(2.75),
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[700],
};

export const icon2: SxStyle = {
  color: (p) => p.palette.grey[400],
};

export const action: SxStyle = {
  py: 0.75,
  px: 2,
};
